import { render } from "./PendingTopbar.vue?vue&type=template&id=4d612af6&scoped=true"
import script from "./PendingTopbar.vue?vue&type=script&lang=js"
export * from "./PendingTopbar.vue?vue&type=script&lang=js"

import "./PendingTopbar.vue?vue&type=style&index=0&id=4d612af6&scoped=true&lang=css"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d612af6"]])

export default __exports__